module.exports = __webpack_public_path__ + "media/images/dailySpecialMarker@3x-aaf0b36347f10b9aafc0da9854802d96.png";